export default {
  baseUrl: process.env.NODE_ENV === 'development' ? 'wss://wss.tiansc.top' : 'wss://wss.tiansc.top',
  shareUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:8080/#/' : 'https://tiansc.top/palette/#/',
}
